import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Crown } from 'lucide-react';
import { useSubscription } from '../hooks/useSubscription';

const SubscriptionSuccess: React.FC = () => {
  const { getActiveProduct } = useSubscription();
  const activeProduct = getActiveProduct();

  useEffect(() => {
    // Refresh the page after a short delay to ensure subscription data is updated
    const timer = setTimeout(() => {
      window.location.reload();
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
            <CheckCircle className="h-8 w-8 text-green-600" />
          </div>
          
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Subscription Successful!
          </h2>
          
          <p className="text-lg text-gray-600 mb-8">
            Thank you for subscribing! Your payment has been processed successfully.
          </p>

          {activeProduct && (
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 mb-8">
              <div className="flex items-center justify-center space-x-2 mb-4">
                <Crown className="h-6 w-6 text-yellow-500" />
                <h3 className="text-xl font-semibold text-gray-900">{activeProduct.name}</h3>
              </div>
              <p className="text-gray-600 mb-4">{activeProduct.description}</p>
              <div className="text-2xl font-bold text-green-600">
                R$ {activeProduct.price.toFixed(2)}/{activeProduct.interval}
              </div>
            </div>
          )}

          <div className="space-y-4">
            <Link
              to="/"
              className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-all duration-200 flex items-center justify-center space-x-2"
            >
              <span>Go to Dashboard</span>
              <ArrowRight className="h-4 w-4" />
            </Link>
            
            <Link
              to="/subscription"
              className="w-full border border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-all duration-200 flex items-center justify-center"
            >
              Manage Subscription
            </Link>
          </div>

          <div className="mt-8 p-4 bg-blue-50 rounded-lg">
            <p className="text-sm text-blue-800">
              <strong>What's next?</strong> You now have access to all premium features. 
              Start exploring your new capabilities!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;